import React, { FC } from 'react';
import { Asset, SearchIcon } from '@clearcover/atlas';

import {
  TextInput,
  TextInputProps,
} from 'Shared/components/FormInput/Variants';

import styles from './styles.module.css';

type SearchInputProps = {
  floatingIcon?: boolean;
} & TextInputProps;

export const SearchInput: FC<SearchInputProps> = ({
  className,
  label,
  disabled,
  floatingIcon = true,
  onChange,
  onIconClick,
  tooltip,
  tooltipPosition,
  ...inputProps
}) => {
  const iconSize = floatingIcon ? 16 : 20;
  return (
    <TextInput
      {...inputProps}
      className={className}
      icon={
        <Asset
          icon={SearchIcon}
          className={styles.searchIcon}
          height={iconSize}
          width={iconSize}
          description="Search"
        />
      }
      label={label}
      onChange={onChange}
      onIconClick={!disabled ? onIconClick : undefined}
      labelVariant={floatingIcon ? 'floatingIcon' : 'standard'}
      sizeVariant="medium"
      disabled={disabled}
      tooltip={tooltip}
      tooltipPosition={tooltipPosition}
    />
  );
};
